import styled from 'styled-components'

import { FileUploadInfosNameStyledProps } from './interface'

export const Infos = styled.div`
  width: 100%;
`

export const InfosName = styled.p<FileUploadInfosNameStyledProps>`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ uploaded, theme }) =>
    theme.colors[uploaded ? 'graysOffBlack' : 'graysGray2']};
`

export const InfosSize = styled.span`
  display: block;
  font-size: 1.2rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.graysGray1};
`
